import { Component, computed, input } from "@angular/core";
import { Flight } from "../../../models/flight.model";
import { FlightEditForm } from "../../form/flight-edit-form";
import { FlightEditLookups } from "../../form/flight-edit-lookups";
import { FlightGroupComponent } from "./flight-group/flight-group.component";
import { FuelGroupComponent } from "./fuel-group/fuel-group.component";
import { LegGroupComponent } from "./leg-group/leg-group.component";
import { TimesGroupComponent } from "./times-group/times-group.component";

/** The flight on the left, its leg and its times on the right, and under them the fuel. */
@Component({
    selector: "app-flight-tab",
    imports: [FlightGroupComponent, LegGroupComponent, TimesGroupComponent, FuelGroupComponent],
    templateUrl: "./flight-tab.component.html",
    styleUrl: "./flight-tab.component.scss",
})
export class FlightTabComponent {
    readonly form = input.required<FlightEditForm>();
    readonly flight = input.required<Flight>();
    readonly lookups = input.required<FlightEditLookups>();

    readonly groundRun = computed(() => this.lookups().isGroundRun(this.flight()));
}
